// store/UserAuthSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: localStorage.getItem("userToken") || null,
  isAuthenticated: !!localStorage.getItem("userToken"),
};

const userAuthSlice = createSlice({
  name: "userAuth",
  initialState,
  reducers: {
    userLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      localStorage.setItem("userToken", action.payload.token);
    },
    userLogout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("userToken");
    },
  },
});

export const { userLogin, userLogout } = userAuthSlice.actions;
export default userAuthSlice.reducer;
